import { IRegisteredUser } from '../../../store/reducers/admin/people';
import { useMemo } from 'react';

export interface RegisteredUserProps {
	profile: IRegisteredUser;
}

export default function RegisteredUserRow(
	props: RegisteredUserProps
): JSX.Element {

	const { profile } = props;


	const location = useMemo(() => {
		const loc = profile.locations?.[0];

		if (loc) {
			return `${loc.city}, ${loc.state} ${loc.countryCode}`;
		} else if (profile.values[7]) {
			return profile.values[7];
		}

		return null;
	}, [profile.locations, profile.values]);

	return (
		<li key={profile.uuid} className="registered-users-list-item">
			<div>
				{profile.values[1]} {profile.values[2]}
			</div>
			<div>
				{profile.email ? (
					profile.email
				) : (
					<span className="inactive">Not available</span>
				)}
			</div>
			<div>
				{location ? (
					location
				) : (
					<span className="inactive">Not available</span>
				)}
			</div>
			<div>
				{new Date(profile.created).toLocaleString()}
			</div>
		</li>
	);
}
